import { render, staticRenderFns } from "./ProfileTalentLocations.vue?vue&type=template&id=fd1c0b26"
import script from "./ProfileTalentLocations.vue?vue&type=script&lang=js"
export * from "./ProfileTalentLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports